<template>
  <v-container>
    <div
      :class="[`text-subtitle-1`]"
    >
      <h4>Skill(s)</h4>
    </div>
    <v-row
      v-for="(item, i) in skill_list"
      :key="i"
    >
      <v-col cols="12">
        {{ item.skill }}
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'AppSkill',
  props: ['skill_list', 'remove_skill'],
  data: () => ({ }),
  methods: { },
}
</script>